import React from 'react';
import { Marker } from 'react-leaflet';
import { getIconStatus } from 'src/app/utils/vehicleService';
import RotateIcon from 'src/app/utils/RotateIcon';
import { getVehicleIcon } from 'src/app/utils/vehicleIconCache';

const FALLBACK_ICON_SIZE = [32, 32];

const handleDisplayIcon = (vehicle) => {
  if (!vehicle) {
    return L.icon({
      iconUrl: '/static/iconSvg/cars/car_lost_gsm.svg',
      iconAnchor: [16, 16],
      iconSize: [32, 32],
    });
  }

  if (vehicle.debt) {
    return L.icon({
      iconUrl: '/static/iconSvg/motors/motor_expired.svg',
      iconAnchor: [16, 16],
      iconSize: [32, 32],
    });
  }

  const iconVehicle = getIconStatus(vehicle.device_status, vehicle.vehicle_type);
  let iconObject = RotateIcon.makeIcon(iconVehicle);

  if (typeof iconObject.setRotation === 'function') {
    iconObject = iconObject.setRotation({
      deg: vehicle.direction || 0.001,
    });
  }

  const url = typeof iconObject.getUrl === 'function' ? iconObject.getUrl() : null;
  const size = typeof iconObject.getSize === 'function' ? iconObject.getSize() : null;

  // Chưa vẽ xong thì dùng thẳng ảnh gốc chưa xoay: xe vẫn hiện đúng chỗ thay vì biến mất một nhịp.
  const drawn = typeof url === 'string' && url.startsWith('data:image') && Array.isArray(size);
  const iconUrl = drawn ? url : iconVehicle;
  const iconSize = drawn ? size : FALLBACK_ICON_SIZE;

  return L.icon({
    iconUrl,
    iconAnchor: [iconSize[0] / 2, iconSize[1] / 2],
    iconSize: iconSize,
  });
};

const VehicleMarker = React.forwardRef(
  ({ vehicle, position, isSelected, onClick, markerRef, vehicleIconsRef, opacity, children }, ref) => {
    // Qua kho icon: cùng loại xe, cùng trạng thái, cùng hướng (làm tròn 5°) thì dùng lại ĐÚNG MỘT
    // object. `vehicle` là object mới sau mỗi lô gói WebSocket, nên nếu dựng icon mới mỗi render
    // thì react-leaflet gọi setIcon() mỗi render và Leaflet thay hẳn thẻ <img> — xe nháy liên tục.
    const icon = getVehicleIcon(vehicle, () => handleDisplayIcon(vehicle));

    return (
      <Marker
        position={position}
        icon={icon}
        zIndexOffset={isSelected ? 1000 : 0}
        opacity={opacity}
        eventHandlers={{ click: () => onClick(vehicle) }}
        ref={(r) => {
          if (r) {
            markerRef.current[vehicle.device_id] = r;

            if (!vehicleIconsRef.current[vehicle.device_id]) {
              vehicleIconsRef.current[vehicle.device_id] = icon;
            }
          }

          if (ref) ref(r);
        }}
      >
        {children}
      </Marker>
    );
  }
);

export default React.memo(VehicleMarker);
